import React, { useContext, useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import 'materialize-css'
import { Container, Card, Row, Col, Button } from 'react-materialize'
import { HeaderCittadino } from '../components/HeaderCittadino'
import { PageFooter } from '../components/PageFooter'
import { GlobalContext } from '../context/GlobalState'
import { EsitoOK } from '../components/EsitoOK'
import { EsitoCancel } from '../components/EsitoCancel'
import { EsitoError } from '../components/EsitoError'


export const EsitoPagamentoPage = () => {
    const debug = process.env.REACT_APP_DEBUG === "true"
    const history = useHistory()
    const location = useLocation()

    const queryString = require('query-string')
    const parsed = queryString.parse(location.search)
    const { esito, idCarrello } = parsed
    if (debug) console.log({esito, idCarrello})
    const datiRichiesta = JSON.parse(localStorage.getItem(idCarrello));


    // const richiestaPagamento = JSON.parse(localStorage.getItem("richiestaPagamento"));
    // if (debug) console.log('richiestaPagamento', richiestaPagamento)

    const { carrello, setCarrello, saveContext, cittadino } = useContext(GlobalContext);
    // const richiedente = cittadino ? cittadino.cf : 'anonimo'
    // const [pagamenti, setPagamenti] = useState(null)

    // const getPagamenti = () => {
    //     fetch(process.env.REACT_APP_SERVER_URL + 'pagamenti/' + richiestaPagamento.id + '?richiedente=' + richiedente, {
    //         method: 'GET'
    //     })
    //         .then(response => response.json())
    //         .then(data => { 
    //             console.log({data}); 
    //             setPagamenti(data); 
    //         });
    // }


    // useEffect(() => {
    //     if (carrello.length) {
    //         svuotaCarrello()
    //     }
    // }, [carrello, svuotaCarrello])


    useEffect(
        () => {
            if (!carrello.length) {
                if (datiRichiesta && datiRichiesta.carrello) {
                    setCarrello(datiRichiesta.carrello)
                    saveContext()
                }
            }
        }, 
        [datiRichiesta, carrello]
    )


    // if (richiestaPagamento) {
    //     if (!keys.includes('idSession') || !keys.includes('esito')) {
    //         history.push("/")
    //     } else {
    //         if (richiestaPagamento.idSession !== parsed.idSession) {
    //             history.push("/")
    //         }
    //     }
    // } else {
    //     history.push("/")
    // }

    
    // if (pagamenti === null) {
    //     if (debug) console.log("GET PAGAMENTI")
    //     getPagamenti()
    // }


    // const scaricaRicevuta = (idDominio, iuv, ccp) => {
    //     let url = process.env.REACT_APP_SERVER_URL + 'rpp/' + idDominio + '/' + iuv + '/' + ccp + '/rt?richiedente=' + richiedente
    //     if (debug) console.log(url)
    //     fetch(url, {
    //         method: 'GET',
    //         headers: { 
    //             'Accept': 'application/pdf'
    //         }
    //     })
    //         .then(res => res.text())
    //         .then(res => {
    //             if (debug) console.log("RICEVUTA", res)
    //             window.open(process.env.REACT_APP_SERVER_URL + 'pdf_ricevute/' + res)
    //         })
    // }


    const switchContent = () => {
        switch (esito) {
            case "OK":
                return <EsitoOK datiRichiesta={datiRichiesta} idCart={idCarrello} />
            case "CANCEL":
                return <EsitoCancel datiRichiesta={datiRichiesta} idCart={idCarrello} />
            case "ERROR":
                return <EsitoError datiRichiesta={datiRichiesta} idCart={idCarrello} />
            default:
                return <p>Esito non riconosciuto</p>
        }
    }


    return (
        <Container>
            <HeaderCittadino history={history} />
            <Row>
                <Col s={12}>
                    { switchContent() }
                    {/* <Card>
                        <Row>
                            <Col>
                                <h4>PROCEDURA DI PAGAMENTO TERMINATA</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <b>ID SESSIONE:</b>
                            </Col>
                            <Col>
                                {richiestaPagamento.idSession}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <b>ID PAGAMENTO:</b>
                            </Col>
                            <Col>
                                {richiestaPagamento.id}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <b>STATO:</b>
                            </Col>
                            <Col>
                                {pagamenti?.stato}
                            </Col>
                        </Row>
                    </Card> */}
                </Col>
            </Row>
            {/* <Row>
                <Col s={12}>
                    <h3>Pagamenti eseguiti</h3>
                </Col>
            </Row>
            <Row>
                <Col s={12}>
                    {
                        pagamenti ?
                        pagamenti?.rpp?.map(
                            (item, i) => <Card key={i}>
                                <Row style={{marginBottom: 0}}>
                                    <Col s={12}>
                                        <b>causale:</b> {item?.pendenza?.causale}
                                    </Col>
                                </Row>
                                <Row style={{marginBottom: 0}}>
                                    <Col s={12}>
                                        <b>importo:</b> € {item?.pendenza?.importo}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col s={12}>
                                        <b>beneficiario:</b> {item?.pendenza?.dominio?.ragioneSociale}
                                    </Col>
                                </Row>
                                {
                                    item?.rt ?
                                    <Row>
                                        <Col s={12}>
                                            <b>esito:</b> {item?.rt ? item.rt.datiPagamento.datiSingoloPagamento[0].esitoSingoloPagamento : "ANNULLATO"}
                                        </Col>
                                    </Row> :
                                    <></>
                                }
                                <Row style={{marginBottom: 0}}>
                                    <Col s={12}>
                                        <Button disabled={!item.rt} onClick={() => {scaricaRicevuta(item?.pendenza?.dominio?.idDominio, item?.rpt?.datiVersamento?.identificativoUnivocoVersamento, item?.rpt?.datiVersamento?.codiceContestoPagamento)}}>SCARICA LA RICEVUTA DEL PAGAMENTO</Button>
                                    </Col>
                                </Row>
                            </Card>
                        ) :
                        <p>GENERAZIONE DELLE RICEVUTE TELEMATICHE IN CORSO, ATTENDERE QUALCHE SECONDO...</p>
                    }
                </Col>
            </Row>
            <Row>
                <Col s={12}>
                    <p><b>Potrai scaricare le ricevute dei tuoi pagamenti accedendo al tuo profilo tramite SPID/CIE o tramite l'app IO</b></p>
                </Col>
            </Row> */}
            <PageFooter />
        </Container>
    )
}